<template>
    <div class="app-layout">
        <div class="system-callout cookie-callout" ref="cookieCallout">
            <div class="system-callout-internal">
                <p>Mājaslapā skolotajiem.fizmix.lv tiek izmantotas sīkdatnes. Turpinot lietot tīmekļa vietni vai nospiežot pogu "Piekrītu", jūs apliecināt savu piekrišanu sīkdatņu izmantošanai. <router-link :to="{ name: 'page', params: { slug: 'informacija-sikdatnes' } }">Uzzināt vairāk</router-link></p>
                <button class="button primary float-right" @click="closeCookieCallout()">Piekrītu</button>
            </div>
        </div>
        <top-bar class="app-header"></top-bar>
        <div class="app-content">
            <slot></slot>
        </div>
        <site-footer class="app-footer"></site-footer>
    </div>
</template>

<script>
    import TopBar from '../components/TopBar'
    import SiteFooter from '../components/Footer'
    import Cookies from 'js-cookie'

    export default {
        mounted() {
            let cookieCallout = this.$refs.cookieCallout;

            if (!Cookies.get('cookie')) {
                cookieCallout.classList.add('show');
                cookieCallout.querySelector('button').addEventListener('click', function (e) {

                })
            }
        },

        methods: {
            closeCookieCallout() {
                let cookieCallout = this.$refs.cookieCallout;
                Cookies.set('cookie', true);
                cookieCallout.classList.remove('show');
            }
        },

        components: { TopBar, SiteFooter }
    }
</script>

<style lang="scss">
    @import "../../sass/settings";
    @import "../../sass/mixins";
    @import "../../sass/foundation/config";

    .app-layout {
        min-height: 100%;
        display: flex;
        flex-direction: column;

        .app-header,
        .app-footer {
            flex-grow: 0;
        }

        .app-content {
            flex-grow: 1;
        }
    }

    .system-callout {
        margin: 0;
        background-color: $color-dark-gray;
        text-align: center;
        width:100%;
        padding: 1em 2em;
        position: fixed;
        bottom: 0;
        z-index: 10;
        display: none;

        &.show {
            display: block;
        }

        @include breakpoint(large) {
            top: 0;
            bottom: unset;
            position: static;
        }


        p {
            color: $color-concrete-gray;
            margin: 0;
        }
    }

    .cookie-callout {
        background-color: #ffaa18;
        text-align: left;
        .system-callout-internal {
            min-height: 36px;
            display: flex;
            align-items: center;
        }
        p {
            color: white;
        }
        a {
            color: white;
            text-decoration: underline;

            &:active,
            &:hover {
                color: white;
                text-decoration: none;
            }
        }
        button {
            margin: 0 0 0 20px;
        }
    }
</style>


// WEBPACK FOOTER //
// resources/assets/js/layouts/AppLayout.vue